// extracted by mini-css-extract-plugin
module.exports = {"summary":"dd31006766--summary--YmUOb","checkout":"dd31006766--checkout--ae6MB","actions":"dd31006766--actions--wl1Ik","actions-buttons":"dd31006766--actions-buttons--TzP2T"};